import {
  fetchPlanningSettings,
  type PlanningSettingsResponse,
} from "../../../../../../../../../../../api/kehrblatt/planning"
import { resolveDefaultBatchAppointmentStartDate } from "../../../../../../../../../_shared/_logic/planning-lead-time"
import {
  ensureOrgBillingPlan,
  type OrgBillingPlanState,
} from "../../../../../../../../../_shared/_logic/org-billing-plan"
import type {
  BatchUploadInit,
  BatchUploadReferenceData,
} from "../_shared/_logic/batch-upload-contract"

export const defaultBatchStartDate = (settings?: PlanningSettingsResponse | null) =>
  resolveDefaultBatchAppointmentStartDate(settings)

export const buildBatchUploadReferenceData = (
  init: Pick<BatchUploadInit, "employees">,
  planningSettings: PlanningSettingsResponse | null,
  billingPlanState: OrgBillingPlanState | null = null,
): BatchUploadReferenceData => ({
  planningSettings,
  billingPlanState,
  defaultStartDate: defaultBatchStartDate(planningSettings),
  employeeOptions: init.employees
    .map((emp) => ({ label: emp.label, value: String(emp.id) }))
    .filter((entry) => entry.value),
})

export const loadBatchUploadReferenceData = async (
  init: Pick<BatchUploadInit, "organizationId" | "employees">,
): Promise<BatchUploadReferenceData> => {
  let planningSettings: PlanningSettingsResponse | null = null
  let billingPlanState: OrgBillingPlanState | null = null

  if (init.organizationId) {
    const [planningResult, billingResult] = await Promise.allSettled([
      fetchPlanningSettings(init.organizationId),
      ensureOrgBillingPlan(init.organizationId, { includePlan: true }),
    ])

    if (planningResult.status === "fulfilled") {
      planningSettings = planningResult.value
    } else {
      console.error("planning_settings_load_failed", planningResult.reason)
    }

    if (billingResult.status === "fulfilled") {
      billingPlanState = billingResult.value
    } else {
      console.error("billing_plan_state_load_failed", billingResult.reason)
    }
  }

  return buildBatchUploadReferenceData(init, planningSettings, billingPlanState)
}
